import Vue from 'vue';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import App from './App.vue';
import router from './router';
import './styles.css';
import { getCurrentUser, isAdmin } from './utils/auth';

Vue.use(ViewUI);
Vue.config.productionTip = false;
Vue.mixin({
  computed: {
    $seeIsAdmin() {
      return isAdmin();
    },
    $seeCurrentUser() {
      return getCurrentUser();
    }
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
